import script from "./CarDriverInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CarDriverInput.vue?vue&type=script&setup=true&lang=js"

import "./CarDriverInput.vue?vue&type=style&index=0&id=09af16ee&lang=css"

const __exports__ = script;

export default __exports__